/*
 * Public API Surface of ngx-lib/address
 */
export * from './address.module';
export * from './address.component';
